export enum LegalPersonType {
  Employee = "Employee",
  Subcontractor = "Subcontractor"
}
